import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Bioseguridad/addBioseguridad`, method: 'POST', body: values, token: token})
}
